import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../../axiosBaseQuery";
import { ENROLLMENT_TOKEN_ENDPOINTS } from "../../../../api/constants";

/**
 * RTK Query API enrollment коннекторов EyeHub.
 *
 * Поток: hub-admin создаёт токен (тело `{org, site}` — именно `org`, не
 * `organization`) → сырой токен показывается ОДИН раз в ответе create (поле
 * `token`) → одобрение (approve) → инсталляция enroll'ится. Утёкший или
 * ошибочно выданный токен гасится отзывом (revoke): это предъявительский
 * секрет с TTL 24 ч, иначе он остаётся валидным до истечения.
 *
 * Контракт токена: {id, org, site, expires_at, single_use, used_at,
 * ops_approved_at, status, created_at, updated_at};
 * status ∈ pending | approved | consumed | expired | revoked.
 * Списки — UnifiedOffsetPagination ({results, count, ...}), фильтры org/site/status.
 */
export const enrollmentApi = createApi({
  reducerPath: "enrollmentApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["EnrollmentToken"],
  endpoints: (builder) => ({
    getEnrollmentTokens: builder.query({
      query: ({ limit = 20, offset = 0, org, site, status, ordering } = {}) => ({
        url: ENROLLMENT_TOKEN_ENDPOINTS.LIST,
        method: "GET",
        params: {
          limit,
          offset,
          ...(org ? { org } : {}),
          ...(site ? { site } : {}),
          ...(status ? { status } : {}),
          ...(ordering ? { ordering } : {}),
        },
      }),
      providesTags: [{ type: "EnrollmentToken", id: "LIST" }],
    }),

    // Создание токена — ответ несёт сырой token ОДИН раз.
    createEnrollmentToken: builder.mutation({
      query: (data) => ({
        url: ENROLLMENT_TOKEN_ENDPOINTS.CREATE,
        method: "POST",
        data,
      }),
      invalidatesTags: [{ type: "EnrollmentToken", id: "LIST" }],
    }),

    approveEnrollmentToken: builder.mutation({
      query: (id) => ({
        url: ENROLLMENT_TOKEN_ENDPOINTS.APPROVE(id),
        method: "POST",
      }),
      invalidatesTags: [{ type: "EnrollmentToken", id: "LIST" }],
    }),

    // Отзыв токена: consume становится невозможен (гашение утёкшего секрета).
    revokeEnrollmentToken: builder.mutation({
      query: (id) => ({
        url: ENROLLMENT_TOKEN_ENDPOINTS.REVOKE(id),
        method: "POST",
      }),
      invalidatesTags: [{ type: "EnrollmentToken", id: "LIST" }],
    }),
  }),
});

export const {
  useGetEnrollmentTokensQuery,
  useCreateEnrollmentTokenMutation,
  useApproveEnrollmentTokenMutation,
  useRevokeEnrollmentTokenMutation,
} = enrollmentApi;

export default enrollmentApi;
